---
title: Landing Page
---

<script lang="ts">
  import ConvertKitForm from '$lib/components/ConvertKitForm.svelte';
  import LandingBenefits from '$lib/components/LandingBenefits.svelte';
  import ProductCTA from '$lib/components/ProductCTA.svelte';

  export let data;
  const title = data.config.landingPage?.title || "Ready to Get Started?";
  const subtitle = data.config.landingPage?.subtitle || `Join thousands of others who are already using ${data.config.productName} to transform their approach.`;
</script>

# {title}

{subtitle}

<ConvertKitForm config={data.config} className="landing-form" />
<LandingBenefits config={data.config} />
<ProductCTA product={data.config.product} />

